import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InspectionReportInitService } from '../../initial-values/inspection-report-init.service';

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportFilesApiService {
  url: string;

  constructor(
    private readonly http: HttpClient,
    private readonly initService: InspectionReportInitService,
  ) {
    this.url = this.initService.getInitValueProperty('urls').files;
  }

  getFile = (fileId: string) =>
    this.http.get(`${this.url}/${fileId}`, {
      observe: 'response',
      responseType: 'blob',
    });
}
